import React from 'react';
import { connect } from 'react-redux';
import './results.scss';

import ga from '../../util/googleAnalytics';

import { eventByType } from '../../api/eventsApi';
import tagular from '../../util/tagular';
import {
    propExistsAndNonEmpty,
    getQueryParameters,
    serializeQueryParameters
} from '../../util/utils';
import { getResultsPath } from '../../util/pathConstructor';
import DefaultResults from './resultsTemplates/defaultResults';
import ResultsB from './resultsTemplates/resultsB';
import ResultsC from './resultsTemplates/resultsC';
import ContentResults from './resultsTemplates/contentResults';
import ScoreResults from './resultsTemplates/scoreResults';

class Results extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0);

        const { assessment, selectedFilters } = this.props;

        if (propExistsAndNonEmpty(assessment)) {
            this.props.updateFilteredResults(selectedFilters);
            this.props.updateProgress(null);

            ga.sendPageview(this.props, assessment.resultsConfig.header.title);
        }

        this.handleFiltersQSOnlLoad();
    }

    componentDidUpdate(prevProps) {
        const { assessment, selectedFilters } = this.props;

        if (assessment !== prevProps.assessment) {
            if (this.resultsUnavailable()) {
                this.props
                    .fetchResults(assessment.name)
                    .then(() => this.props.updateFilteredResults(this.props.selectedFilters));
            }

            this.props.updateProgress(null);

            ga.sendPageview(this.props, assessment.resultsConfig.header.title);
        }

        if (selectedFilters !== prevProps.selectedFilters) {
            this.props.resultsLoading();

            setTimeout(() => {
                this.props.updateFilteredResults(selectedFilters);
            }, 500);

            this.handleFiltersQSOnUpdate();
        }
    }

    componentWillUnmount() {
        this.props.clearPromptQueue();
    }

    handleFiltersQSOnlLoad() {
        const { location } = this.props;

        const filtersQueryStr = getQueryParameters(location.search).q;

        if (filtersQueryStr) {
            const filters = filtersQueryStr.split(',');
            this.props.receiveAggregateFilters(filters);
        }
    }

    handleFiltersQSOnUpdate() {
        const { location, selectedFilters, assessment } = this.props;

        if (propExistsAndNonEmpty(assessment)) {
            const qs = getQueryParameters(location.search);

            if (selectedFilters.length > 0) {
                const filters = selectedFilters.join(',');
                qs.q = filters;
            } else {
                delete qs.q;
            }

            const resultsPath = getResultsPath(assessment.name, `?${serializeQueryParameters(qs)}`);
            this.props.history.replace(resultsPath);
        }
    }

    resultsUnavailable() {
        return !this.props.allResults || this.props.allResults.length < 1;
    }

    render() {
        const { assessment, inlineParentMetadata } = this.props;

        let headerInfo = {
            title: 'Your Top Results',
            description: 'Your results based on your answers.'
        };

        let ResultsTemplate = DefaultResults;
        if (propExistsAndNonEmpty(assessment)) {
            headerInfo = assessment.resultsConfig.header;

            if (assessment.resultsConfig.displayType === 'score') {
                ResultsTemplate = ScoreResults;
            }

            if (assessment.resultsConfig.template) {
                switch (assessment.resultsConfig.template) {
                    case 'B':
                        ResultsTemplate = ResultsB;
                        break;
                    case 'C':
                        ResultsTemplate = ResultsC;
                        break;
                    case 'Content':
                        ResultsTemplate = ContentResults;
                        break;
                    default:
                }
            }
        }

        let modal;
        if (headerInfo.modal) {
            const { copy, type } = headerInfo.modal;

            modal = (
                <em
                    className="rate modal-link"
                    onClick={e => {
                        eventByType('how-we-rated-these-diets', assessment.id, {
                            inlineParentMetadata
                        });
                        tagular.sendElementClickedEvent(e, {
                            assessmentName: assessment.internalName,
                            name: headerInfo.title,
                            action: 'OPEN'
                        });
                        this.props.openModal(type);
                    }}
                >
                    {' '}
                    {copy}
                </em>
            );
        }

        return <ResultsTemplate headerInfo={headerInfo} modal={modal} site={assessment.site}/>;
    }
}

const mapStateToProps = state => {
    return {
        inlineParentMetadata: state.inline.parentMetadata
    };
};

export default connect(mapStateToProps, null)(Results);
